import EditCvModal from './EditCvModal';

export default EditCvModal;